import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';

import template from './TimeSlot.html?raw';
// NOTE (JS2TS): dropped dead deps dojo/dom-construct, dojo/dom-style, dojo/on, dojo/query (imported but unused).

class TimeSlot extends compose(_WidgetBaseSP) {
    [key: string]: any;
    templateString: any = template;

    selectedStyleNames: any = {
        "default": "default",
        "selected": "selected",
        "locked": "locked"
    };

    entity: any = null;
    startDate: any = null;
    endDate: any = null;
    duration: any = null;
    selected = false;
    locked = false;
    groupWidget: any = null;
    permanentColor: any = null; // der slot hat immer diese farbe. unabhängig vom Zustand

    title = "";

    constructor(args: any) {
        super(...(arguments as unknown as []));
        lang.mixin(this, args);
    }

    canSelect(timeSlotWidget: any) {
        return true; // kann überschrieben werden
    }

    _setDurationAttr(duration: any) {
        this.duration = duration;
        if (this.startDate != null) {
            this.endDate = new Date(this.startDate.getTime() + this.duration * 60000);
        }
    }

    _setSelectedAttr(value: any) {
        this.selected = value;
        this.displaystate();
    }

    _getSelectedAttr() {
        return this.selected;
    }

    _setLockedAttr(value: any) {
        this.locked = value;
        this.displaystate();
    }

    _getLockedAttr() {
        return this.locked;
    }

    _onClick_TimeSlot(evt: any) {
        if (this.groupWidget.readOnly === true) {
            return;
        }

        this.select();
    }

    select(silent?: any) {
        if (this.get("locked") == true) {
            return;
        }

        if (this.canSelect(this) !== true) {
            return;
        }

        this.set("selected", !this.selected);
        this.emit("selected", this);
    }

    setupMapping() {} // dummy ... wird in der TimeSlotGroup überschrieben

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.drawContent();
    }

    drawContent() {
        (this as any).setupMapping(this);
        domAttr.set(this.titleNode, "innerHTML", this.title);

        this.displaystate();
    }

    displaystate() {
        if (this.locked === true) {
            // Reihenfolge wichtig! locked muss vor selected kommen

            domClass.remove(this.domNode, this.selectedStyleNames["selected"]);
            domClass.remove(this.domNode, this.selectedStyleNames["default"]);

            domClass.add(this.domNode, this.selectedStyleNames["locked"]);
        } else if (this.selected === true) {
            domClass.remove(this.domNode, this.selectedStyleNames["locked"]);
            domClass.remove(this.domNode, this.selectedStyleNames["default"]);

            domClass.add(this.domNode, this.selectedStyleNames["selected"]);
        } else {
            domClass.remove(this.domNode, this.selectedStyleNames["selected"]);
            domClass.remove(this.domNode, this.selectedStyleNames["locked"]);

            domClass.add(this.domNode, this.selectedStyleNames["default"]);

            if (this.permanentColor != null) {
                this.domNode.style.setProperty("background", this.permanentColor, "important");
            } else {
                this.domNode.style.setProperty("background", "");
            }
        }
    }

}
TimeSlot.prototype.declaredClass = 'more.Controls.TimeSlotPicker.TimeSlot';

export default mdsWidget(TimeSlot);
